import React from 'react';
import { WarehouseIcon } from 'lucide-react';
import { useWarehouse } from '../../contexts/WarehouseContext';

/**
 * Read-only badge showing the operator's assigned warehouse.
 * Hidden when the tenant has only one warehouse.
 */
export const WarehouseIndicator: React.FC = () => {
  const { currentWarehouse, currentWarehouseName, warehouses, isLoading } = useWarehouse();

  // Hide if no warehouse assigned or only one warehouse exists
  if (!currentWarehouse || (warehouses.length <= 1 && !isLoading)) {
    return null;
  }

  return (
    <div
      className="hidden sm:flex items-center gap-1.5 px-2.5 py-1 bg-blue-50 text-blue-700 rounded-md text-xs font-medium border border-blue-200"
      title={`Tilknyttet lager: ${currentWarehouseName || currentWarehouse}`}
    >
      <WarehouseIcon size={14} />
      <span className="whitespace-nowrap">{currentWarehouseName || currentWarehouse}</span>
    </div>
  );
};
